import React from "react";
import DashboardDatePicker from "../DashboardDatePicker/DashboardDatePicker";
import { isSameDay } from "date-fns";

class RatesDashboardDatepicker extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeDate = this.onChangeDate.bind(this);
    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onChangeView = this.onChangeView.bind(this);
  }

  render() {
    var today = new Date(this.props.tempStartDate);

    return (
      <div className="row dashboard-buttons">
        <div className="col-sm-12">
          <div
            className="prev-button pull-right"
            style={{ display: 'none', position: "relative", zIndex: 100, textAlign: "right" }}
          >
            <div className="btn-group pull-right" role="group">
              <button
                type="button"
                className={
                  "btn btn-secondary " +
                  (this.props.tempDateView == "week" ? "active" : "")
                }
                onClick={this.onChangeView}
                data-view="week"
              >
                {I18n.t("week")}
              </button>
              {/* <button
                type="button"
                className={
                  "btn btn-secondary " +
                  (this.props.tempDateView == "month" ? "active" : "")
                }
                onClick={this.onChangeView}
                data-view="month"
              >
                {I18n.t("month")}
              </button> */}
            </div>
          </div>
          <div
            className="text-center"
            style={{ position: "absolute", left: 0, right: 0 }}
          >
            <button
              type="button"
              className="prev-button btn btn-dark"
              onClick={this.onPrev}
            >
              <span className="icon ss-left"></span>
            </button>
            {isSameDay(new Date(today), new Date()) ? (
              <DashboardDatePicker
                classNames={"current-date"}
                selected={today}
                dateFormat={this.props.dateFormat}
                selectedDate={today}
                onChange={this.onChangeDate}
              />
            ) : (
              <DashboardDatePicker
                selected={today}
                dateFormat={this.props.dateFormat}
                selectedDate={today}
                onChange={this.onChangeDate}
              />
            )}

            <button
              type="button"
              className="next-button btn btn-dark"
              onClick={this.onNext}
            >
              <span className="icon ss-right"></span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  onChangeDate(date) {
    this.props.onChangeDate(date);
  }

  onChangeView(e) {
    e.preventDefault();

    this.props.onChangeDateView(e.target.dataset.view);
  }

  onToday() {
    DashboardActions.gotoDate(new Date());
  }

  onPrev() {
    var prevDate = new Date(this.props.tempStartDate);

    if (this.props.dateView === "week") {
      prevDate.setDate(prevDate.getDate() - 7);
    } else if (this.props.dateView === "month") {
      prevDate.setDate(prevDate.getDate() - 31);
    } else {
      prevDate.setDate(prevDate.getDate() - 1);
    }

    this.props.onChangeDate(prevDate);
  }

  onNext() {
    var nextDate = new Date(this.props.tempStartDate);

    if (this.props.dateView === "week") {
      nextDate.setDate(nextDate.getDate() + 7);
    } else if (this.props.dateView === "month") {
      nextDate.setDate(nextDate.getDate() + 31);
    } else {
      nextDate.setDate(nextDate.getDate() + 1);
    }

    this.props.onChangeDate(nextDate);
  }
}

export default RatesDashboardDatepicker;
